exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._14xoDFq-EqJ3vwm_AmcO5Q {\n    margin-top: 32px;\n    margin-bottom: 32px;\n}", ""]);

// exports
exports.locals = {
	"root": "_14xoDFq-EqJ3vwm_AmcO5Q"
};